import React from 'react'
import { CurrencyFormat } from '../../../helpers/formatting'
import { sortData, handleSort } from './chirpResultsHelpers'
import SortableColumnHeader from './SortableColumnHeader'
import CollapsibleTableSection from './CollapsibleTableSection'

const COLUMNS = [
  { column: 'category', label: 'Category' },
  { column: 'amount', label: 'Amount' },
  { column: 'percent', label: 'Percentage' },
]

const ExpenseBreakdownTable = ({ data, expanded, onToggle, sortState, setSortState }) => (
  <CollapsibleTableSection
    title={`Expense Breakdown (${data.length} items)`}
    expanded={expanded}
    onToggle={onToggle}
  >
    <div className="list-table-container">
      <table className="lox-hooktable-table table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead>
          <tr className="is-selected">
            {COLUMNS.map(({ column, label }) => (
              <SortableColumnHeader
                key={column}
                label={label}
                column={column}
                sortState={sortState}
                onSort={() => handleSort(setSortState, column)}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {sortData(data, sortState.column, sortState.direction).map((expense) => (
            <tr key={`expense-${expense.category}`}>
              <td className="has-text-centered is-nowrap">{expense.category}</td>
              <td className="has-text-centered is-nowrap">{CurrencyFormat({ value: expense.amount })}</td>
              <td className="has-text-centered is-nowrap">{expense.percent.toFixed(1)}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </CollapsibleTableSection>
)

export default ExpenseBreakdownTable
